import { QueryKey } from '@/enums';
import { TenantEntity } from '@/interfaces';
import { AuthService } from '@/services';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { get } from 'lodash';

const useGetTenantQuery = (options?: Partial<UseQueryOptions>) => {
  const query = useQuery({
    queryKey: [QueryKey.SUB_DOMAIN],
    queryFn: AuthService.getSubdomain,
    staleTime: Infinity,
    ...options,
  });

  const tenant = get(query, 'data.data', {}) as TenantEntity;
  return { ...query, tenant };
};
export { useGetTenantQuery };
